import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IPropertyData } from '@lassi/webapp-shared';
import {
  DisallowedValuesPipe,
  GeographicCoordsPipe,
  LatLngPipe,
  MGAPipe,
  PointPipe,
} from '@lassi/webapp-shared-pipes';
import type { Point } from 'leaflet';

@Component({
  selector: 'lib-property-info-general-tab',
  imports: [
    DisallowedValuesPipe,
    LatLngPipe,
    GeographicCoordsPipe,
    MGAPipe,
    PointPipe,
  ],
  template: `
    <h3 class="mat-title-medium">General</h3>
    <div class="identify-grid">
      @if (general().lga_name | disallowedValues: ['N', null, '']) {
        <span class="mat-body-small">LGA:</span>
        <span class="mat-body-small">{{ general().lga_name }}</span>
      }

      @if (general().lga_code | disallowedValues: ['N', null, '']) {
        <span class="mat-body-small">LGA Code:</span>
        <span class="mat-body-small">{{ general().lga_code }}</span>
      }

      @if (general().locality_name | disallowedValues: ['N', null, '']) {
        <span class="mat-body-small">Locality:</span>
        <span class="mat-body-small">{{ general().locality_name }}</span>
      }

      @if (general().parish_name | disallowedValues: ['N', null, '']) {
        <span class="mat-body-small">Parish:</span>
        <span class="mat-body-small">{{ general().parish_name }}</span>
      }

      @if (general().parish_code | disallowedValues: ['N', null, '', '9999']) {
        <span class="mat-body-small">Parish Code:</span>
        <span class="mat-body-small">{{ general().parish_code }}</span>
      }

      @if (general().township_name | disallowedValues: ['N', null, '']) {
        <span class="mat-body-small">Township Name:</span>
        <span class="mat-body-small">{{ general().township_name }}</span>
      }

      @if (
        general().township_code | disallowedValues: ['N', null, '', '9999']
      ) {
        <span class="mat-body-small">Township Code:</span>
        <span class="mat-body-small">{{ general().township_code }}</span>
      }
    </div>

    <h3 class="mat-title-medium">Coordinates</h3>
    <div class="identify-grid">
      @let latlng = coords() | latlng;

      <span class="mat-body-small">GDA2020:</span>
      <span class="mat-body-small">{{ latlng | geographicCoords }}</span>
      <span class="mat-body-small">MGA2020:</span>
      @let mga = latlng | mga;
      <span class="mat-body-small">
        {{ mga.point | point: 1 }} ({{ mga.name }})
      </span>
    </div>
  `,
  styles: `
    @use 'shared' as *;

    @include identify-grid();
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyInfoGeneralTabComponent {
  general = input.required<IPropertyData['general']>();
  coords = input.required<Point>();
}
